import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PolicyPage.css';

const TermsOfService = () => {
    const navigate = useNavigate();

    return (
        <div className="policy-page">
            <button className="policy-back-btn" onClick={() => navigate(-1)}>
                ← Back
            </button>

            <div className="policy-container">
                <h1>Terms of Service</h1>
                <p className="policy-meta">Last updated: June 2025 &nbsp;·&nbsp; VerDict AI</p>

                <h2>1. Acceptance of Terms</h2>
                <p>
                    By accessing or using VerDict AI (&quot;the Service&quot;) you agree to be bound by these Terms of Service.
                    If you do not agree, do not use the Service.
                    These terms apply to all users of the prototype.
                </p>

                <h2>2. Description of Service</h2>
                <p>
                    VerDict AI is an AI-powered fact-checking prototype that analyses text, links, and images
                    to provide informational verdicts on the likely accuracy of content.
                    The Service is provided for research and evaluation purposes only and is <strong>not intended
                    as a definitive source of truth</strong>.
                </p>

                <h2>3. Prototype Nature of the Service</h2>
                <p>
                    You acknowledge that:
                </p>
                <ul>
                    <li>The Service is a <strong>prototype / beta product</strong> and may be unstable, incomplete, or inaccurate.</li>
                    <li>Features, data, and availability may change or be removed at any time without notice.</li>
                    <li>Query history and account data may be reset periodically.</li>
                    <li>The Service should not be used for high-stakes decisions involving legal, medical, financial, or safety matters.</li>
                </ul>

                <h2>4. AI Limitations &amp; Accuracy Disclaimer</h2>
                <p>
                    AI-generated verdicts are probabilistic estimates, not guarantees of accuracy.
                    VerDict AI may produce incorrect, biased, or incomplete results.
                    Always verify important claims through authoritative primary sources.
                    We expressly disclaim any liability for decisions made in reliance on the Service&apos;s output.
                </p>

                <h2>5. User Responsibilities</h2>
                <p>You agree to:</p>
                <ul>
                    <li>Provide accurate registration information (name and email).</li>
                    <li>Use the Service only for lawful purposes.</li>
                    <li>Not submit content that is illegal, defamatory, obscene, or that infringes third-party rights.</li>
                    <li>Not attempt to reverse-engineer, scrape, overload, or otherwise abuse the Service.</li>
                    <li>Not use automated tools to submit queries in bulk without prior written permission.</li>
                </ul>

                <h2>6. Intellectual Property</h2>
                <p>
                    All software, design, and branding elements of VerDict AI are owned by or licensed to us.
                    You may not copy, modify, distribute, or create derivative works without our prior written consent.
                    Content you submit remains yours; by submitting it you grant us a limited licence to process it
                    solely for the purpose of providing the Service.
                </p>

                <h2>7. No Warranties</h2>
                <p>
                    THE SERVICE IS PROVIDED &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot; WITHOUT WARRANTIES OF ANY KIND,
                    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY,
                    FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
                    WE DO NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED, ERROR-FREE, OR ACCURATE.
                </p>

                <h2>8. Limitation of Liability</h2>
                <p>
                    TO THE FULLEST EXTENT PERMITTED BY LAW, VERDICTAI AND ITS OPERATORS SHALL NOT BE LIABLE
                    FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF
                    OR RELATED TO YOUR USE OF THE SERVICE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
                    OUR TOTAL LIABILITY SHALL NOT EXCEED USD $0 FOR A FREE PROTOTYPE SERVICE.
                </p>

                <h2>9. Termination</h2>
                <p>
                    We reserve the right to suspend or terminate your access at any time, for any reason,
                    including but not limited to violation of these Terms.
                    You may stop using the Service at any time.
                </p>

                <h2>10. Changes to These Terms</h2>
                <p>
                    We may update these Terms as the Service evolves. Continued use after changes constitutes acceptance.
                    The &quot;Last updated&quot; date at the top reflects the most recent revision.
                </p>

                <h2>11. Governing Law</h2>
                <p>
                    These Terms are governed by the laws of the State of New York, United States,
                    without regard to conflict-of-law principles.
                </p>

                <h2>12. Contact</h2>
                <p>
                    Questions about these Terms? Contact us at{' '}
                    <a href="mailto:support@verdictai.news">support@verdictai.news</a>.
                </p>
            </div>
        </div>
    );
};

export default TermsOfService;
